module.exports = __webpack_public_path__ + "static/media/map.07f66cd8.svg";